import { render, staticRenderFns } from "./RazaoAnaliticoReport.vue?vue&type=template&id=4b641e4c"
import script from "./RazaoAnaliticoReport.vue?vue&type=script&lang=js"
export * from "./RazaoAnaliticoReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports